import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";

import { Guid } from "@/Common/Models/Guid";
import { SecondScreenNoteData } from "@/Common/Models/SecondScreenNoteData";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { SecondScreenNoteService } from "@/Common/Services/SecondScreenNoteService";
import { PrescriptionRenewalInboxSettings } from "../Models/PrescriptionRenewalInboxSettings";
import { PrescriptionRenewalsInbox } from "./PrescriptionRenewalsInbox";
import { PrescriptionRenewalsView } from "./PrescriptionRenewalsView";

function PrescriptionRenewalsRoutes(): JSX.Element {
    const navigate = useNavigate();
    useEffect(() => {
        if (!prescriptionRenewalsStore?.prescriptionRenewalInboxSettings) {
            sessionStore.dispatch(
                LocalOperations.PrescriptionRenewal.SetPrescriptionRenewalInboxSettings,
                { prescriptionRenewalInboxSettings: new PrescriptionRenewalInboxSettings() }
            );
        }
    }, []);

    return (
        <>
            <Routes>
                {["", "*"].map(p => (
                    <Route
                        key={p}
                        path={p}
                        element={(
                            <PrescriptionRenewalsInbox
                                onRenewalsClick={(prescriptionRenewalId: Guid, prescriptionRenewalInboxSettings: PrescriptionRenewalInboxSettings): void => {
                                    sessionStore.dispatch(
                                        LocalOperations.PrescriptionRenewal.SetPrescriptionRenewalInboxSettings,
                                        { prescriptionRenewalInboxSettings: prescriptionRenewalInboxSettings }
                                    );
                                    navigate(`/prescriptionrenewals/${prescriptionRenewalId}/renewMedication`);
                                }}
                                queryCurrentPageNumber={prescriptionRenewalsStore?.prescriptionRenewalInboxSettings?.currentPageNumber}
                            />
                        )}
                    />
                ))}
                <Route
                    path=":prescriptionRenewalId/*"
                    element={(
                        <PrescriptionRenewalsView
                            prescriptionRenewalInboxSettings={prescriptionRenewalsStore?.prescriptionRenewalInboxSettings}
                            onCancelClick={(queryCurrentPageNumber: number) => {
                                if (SecondScreenNoteService.getInstance().isChildWindowOpen()) {
                                    SecondScreenNoteService.getInstance().updateModel(new SecondScreenNoteData({ patientId: null }));
                                }
                                sessionStore.dispatch(
                                    LocalOperations.PrescriptionRenewal.SetPrescriptionRenewalInboxSettings,
                                    { prescriptionRenewalInboxSettings: { ...prescriptionRenewalsStore?.prescriptionRenewalInboxSettings, currentPageNumber: queryCurrentPageNumber } }
                                );
                            }}
                        />
                    )}
                />
            </Routes>
        </>
    );
}

export { PrescriptionRenewalsRoutes };
